export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f19d6733762f119b69b71d395d1e01db3bb28cc03&name=fetchTypeahead!'